export class EmailSetup {
    id : string;
    departmentId : string;
    userId: string;
    emailReferenceType: number;	
}

export class EmailSetupAddModel extends EmailSetup{    
       
}